/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $SendNewTaxFormRequest = {
  properties: {
    cnpj: {
      type: 'string',
      isRequired: true,
    },
  },
} as const;
